import * as resizeImage from 'resize-image'


export const dataURItoBlob = (dataURI) => {
  // from https://stackoverflow.com/questions/19032406/convert-html5-canvas-into-file-to-be-uploaded
  // convert base64/URLEncoded data component to raw binary data held in a string
  let byteString;
  if (dataURI.split(',')[0].indexOf('base64') >= 0)
    byteString = atob(dataURI.split(',')[1]);
  else
    byteString = unescape(dataURI.split(',')[1]);
  // separate out the mime component
  let mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
  // write the bytes of the string to a typed array
  let ia = new Uint8Array(byteString.length);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  return new Blob([ia], {type:mimeString});
}

export const addImageProcess = (src) =>{
  return new Promise((resolve, reject) => {
    let img = new Image();
    img.onload = () =>  {
      const data = resizeImage.resize(img, 400, 500, resizeImage.JPEG);
      resolve(data)
    };
    img.onerror = reject;
    img.src = src
  })
}

export const imageToBlobUrl = async (image) => {
  return await fetch(image)
    .then(res => res.blob()) // Gets the response and returns it as a blob
    .then(blob => {
      // Here's where you get access to the blob
      // And you can use it for whatever you want
      // Like calling ref().put(blob)

      // Here, I use it to make an image appear on the page
      let objectURL = URL.createObjectURL(blob);
      return objectURL;
    });
}

export const removeTokenFromUrl = (url) => {
  const tokenStartIndex = url.indexOf("&token=")

  if(tokenStartIndex > 0) {
    return url.substring(0, tokenStartIndex)
  } else {
    return url;
  }
}

